<template>
  <v-container fluid full-height grid-list-md>
    <v-layout row wrap>
      <v-flex xs6>
        <div class="text-xs-left">
          <v-breadcrumbs :items="breadcrumbs" divider=">"></v-breadcrumbs>
        </div>
      </v-flex>
      <v-flex xs6>
        <div class="text-xs-right">
          <v-btn color="primary" @click="onRegister">
            New Card
            <v-icon right>add_circle</v-icon>
          </v-btn>
        </div>
      </v-flex>
      <v-flex xs12>
        <v-card>
          <v-layout row wrap class="pa-3">
            <v-flex sm3>
              <v-text-field name="cardNo" label="Card No" type="text" v-model="queryParams.cardNo"></v-text-field>
            </v-flex>
            <v-flex sm3>
              <v-select
                :items="shopList"
                label="Shop"
                v-model="queryParams.shopId"
                item-text="name"
                item-value="id"
              ></v-select>
            </v-flex>
            <v-flex sm3>
              <v-select
                :items="statusList"
                label="Status"
                v-model="queryParams.status"
                item-text="label"
                item-value="value"
              ></v-select>
            </v-flex>
            <v-flex sm3>
              <v-btn outline color="primary" @click="onSearch">
                Search
                <v-icon right>search</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
      <!-- <v-flex d-flex xs12>
        <v-card>
          <v-card-text class="font-weight-bold">
            <div>
              <v-btn
                :loading="exportAllButtonLoading"
                color="success"
                @click="getExportAllCard()"
              >EXPORT ALL</v-btn>
            </div>
          </v-card-text>
        </v-card>
      </v-flex>-->
      <v-flex xs12 class="mt-1">
        <v-card>
          <v-data-table
            :headers="headers"
            :items="cardList"
            class="elevation-1"
            :loading="showListLoading"
            :total-items="totalRows"
            :rows-per-page-items="rowsPerPageItems"
            :pagination.sync="pagination"
            :must-sort="true"
          >
            <template slot="items" slot-scope="props">
              <td>{{ props.item.cardNo }}</td>
              <td>{{ props.item.shop.name }}</td>
              <td>{{ props.item.description }}</td>
              <td>{{ props.item.updatedDateInMilliSeconds | format-ms-date-time }}</td>
              <td>{{ props.item.updatedBy }}</td>
              <td>
                <v-icon v-if="props.item.status=='ACTIVE'" medium color="green">check_circle</v-icon>
                <v-icon v-else medium color="red">cancel</v-icon>
              </td>
              <td>
                <v-btn flat icon color="blue lighten-2" @click="onEdit(props.item)">
                  <v-icon>edit</v-icon>
                </v-btn>
              </td>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { cardService } from "../../services/card-service";
import { shopService } from "../../services/shop-service";
export default {
  name: "CardList",

  components: {},
  data: () => ({
    showListLoading: false,
    openDialog: false,
    breadcrumbs: [
      {
        text: "General",
        disabled: true
      },
      {
        text: "Card",
        disabled: true
      }
    ],
    headers: [
      { text: "Card No", align: "left", value: "cardNo" },
      { text: "Shop", value: "shop" },
      { text: "Description", value: "description" },
      { text: "Updated Date", value: "updatedDate" },
      { text: "Updated By", value: "updatedBy" },
      { text: "Status", value: "status", sortable: false },
      { text: "Action", value: "name", sortable: false }
    ],
    rowsPerPageItems: [25, 50, 100],
    pagination: {
      descending: true,
      page: 1,
      rowsPerPage: 50,
      sortBy: "cardNo",
      totalItems: 0
    },
    cardList: [],
    totalRows: 0,
    statusList: [
      { label: "All", value: "" },
      { label: "Active", value: "ACTIVE" },
      { label: "Inactive", value: "INACTIVE" }
    ],
    queryParams: {
      name: "",
      code: "",
      status: "ACTIVE"
    },
    clonequeryParams: new Object(),
    shopList: []
  }),
  watch: {
    pagination: {
      handler() {
        this.getCardList();
      },
      deep: true
    }
  },
  created() {
    //for deep linking
    if (this.$route.query.cardNo) {
      this.queryParams.cardNo = this.$route.query.cardNo;
    }
    if (this.$route.query.shopId) {
      this.queryParams.shopId = this.$route.query.shopId;
    }
    if (this.$route.query.status) {
      this.queryParams.status = this.$route.query.status;
    }
    if (this.$route.query.page) {
      this.pagination.page = this.$route.query.page;
    }
    if (this.$route.query.size) {
      this.pagination.size = this.$route.query.size;
    }
    this.clonequeryParams = Object.assign({}, this.queryParams);
    this.getShopList();
  },

  methods: {
    onSearch() {
      this.queryParams.page = this.pagination.page;
      this.queryParams.size = this.pagination.rowsPerPage;
      this.$router.replace({ name: "cards", query: this.queryParams });
      this.getCardList();
      this.clonequeryParams = Object.assign({}, this.queryParams);
    },
    getCardList() {
      this.showListLoading = true;
      let order = this.pagination.descending ? "desc" : "asc";
      cardService
        .getCardList(
          this.queryParams,
          this.pagination.page,
          this.pagination.rowsPerPage,
          this.pagination.sortBy + "," + order
        )
        .then(res => {
          if (res.data) {
            this.cardList = res.data.cardList;
            this.totalRows = res.data.totalElements;
          }
        })
        .catch(err => {
          console.log(err);
        })
        .finally(() => {
          this.showListLoading = false;
        });
    },
    getShopList() {
      shopService
        .getAllShop()
        .then(res => {
          this.shopList = res.data;
        })
        .catch(err => {
          console.log(err);
        });
    },
    onRegister() {
      this.$router.push("/card/new");
    },
    onEdit(card) {
      // go to details page
      this.$router.push("/card/" + card.id);
    },
    dialogClose() {
      this.openDialog = false;
      this.getCardList();
    }
    // getExportAllCard() {
    //   this.exportAllButtonLoading = true;
    //   cardService
    //     .exportAllCard(this.clonequeryParams)
    //     .then(res => {
    //       commonService.downloadE(res);
    //     })
    //     .catch(err => {
    //       console.log(err);
    //     })
    //     .finally(() => {
    //       this.exportAllButtonLoading = false;
    //     });
    // }
  }
};
</script>